import ReactDiffViewer from 'react-diff-viewer';
import Button from 'components/Button';
import ModalTitle from 'components/ModalTitle';
import {
    StyledModal, DiffContainer, ModalFooter, TitleContainer, TitleDescription, VersionHint,
} from './styled';

interface VersionsDiffViewerModalProps {
    isOpen: boolean;
    actualVersionContent: string;
    previousVersionContent?: string;
    previousVersionDate?: Date;
    previousVersionAuthor?: string;
    previousVersionNumber?: number;
    onRequestClose: () => void;
    onRestoreVersion?: () => void;
}

const VersionsDiffViewerModal = ({
    isOpen,
    actualVersionContent,
    previousVersionContent,
    previousVersionDate,
    previousVersionAuthor,
    previousVersionNumber,
    onRequestClose,
    onRestoreVersion,
}: VersionsDiffViewerModalProps) => {
    const handleRestoreVersion = () => {
        if (onRestoreVersion) {
            onRestoreVersion();
            onRequestClose();
        }
    };

    // Format date to include both date and time
    const formattedDateTime = previousVersionDate?.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });

    return (
        <StyledModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            borderRadius="semi-square"
            title={(
                <TitleContainer>
                    <ModalTitle>Restore Previous Version</ModalTitle>
                    <TitleDescription>
                        Version
                        {' '}
                        {previousVersionNumber}
                        {' '}
                        by
                        {' '}
                        {previousVersionAuthor}
                        {' '}
                        from
                        {' '}
                        {formattedDateTime}
                    </TitleDescription>
                    <VersionHint>
                        Review changes that will occur if you restore to this version.
                    </VersionHint>
                </TitleContainer>
            )}
            size="large"
            footer={(
                <ModalFooter>
                    <Button
                        variant="neutral"
                        label="Cancel"
                        borderRadius="semi-square"
                        onClick={onRequestClose}
                    />
                    {onRestoreVersion && (
                        <Button
                            variant="brand"
                            label="Restore Version"
                            borderRadius="semi-square"
                            onClick={handleRestoreVersion}
                        />
                    )}
                </ModalFooter>
            )}
        >
            <DiffContainer>
                <ReactDiffViewer
                    oldValue={previousVersionContent}
                    newValue={actualVersionContent}
                    splitView={false}
                    showDiffOnly
                    styles={{
                        contentText: {
                            fontSize: '14px',
                            lineHeight: '1.5',
                        },
                        gutter: {
                            minWidth: '50px',
                        },
                    }}
                />
            </DiffContainer>
        </StyledModal>
    );
};

export default VersionsDiffViewerModal;
